/** @jsxImportSource @emotion/react */
import React, { useState, BaseSyntheticEvent, useCallback, useEffect, useLayoutEffect, useRef, RefObject } from "react";
import queryString from "query-string";
import { isAxiosError } from "axios";
import { useLocation } from "react-router-dom";
import { useForm, SubmitHandler, Controller, useFieldArray } from "react-hook-form";
import { ResponseParamBase } from "../common/Types";
import { UploadFile } from "../common/Util";
import { TextValidation } from "../common/Validation";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { CircularProgress, InputBase, colors } from "@mui/material";
import { ApiUrl } from "../common/Params";
import { UploadImageType } from "../view/components/UploadImage";
import { ChatData, ChatMessageType } from "../view/components/ChatPreview";
import { cht_agent_bubble_cont, cht_agent_container, cht_agent_icon, cht_container, cht_content, cht_customer_bubble_cont, cht_footer, cht_footer_left, cht_customer_container, cht_headber, cht_headber_title, cht_wrapper, config_wrap, bubble, sendButton } from "../css/BaseCss2";
import { css } from "@emotion/react";
import basecss from "../css/base.module.css";
import { useCookies } from "react-cookie";
import { Snack } from "./components/Snack";
import { use100vh } from "react-div-100vh";

type ResponseParam = ResponseParamBase & {
    //chatMessage: ChatData,
    answer: string,
    question: string,
}

export type InitResponseParam = ResponseParamBase & {
    questionTemplate: string,
    backgroundColor: string,
    headerTitle: string,
    headerColor: string,
    headerTextColor: string,
    adminBubbleBackgroundColor: string,
    adminBubbleTextColor: string,
    guestBubbleBackgroundColor: string,
    guestBubbleTextColor: string,
    footerText: string,
    footerBackgroundColor: string,
    footerTextColor: string,
    footerTextareaColor: string,
    footerTextareaPlaceholderColor: string,
    footerButtonIcon: Blob,
    sendButtonColor: string,
    headerImage: Blob,
    chatAdminIcon: Blob,
    chatGuestIcon: Blob,
    initTextList: ChatData[],
}

type PageParam = {
    siteid: string,
    isstream: string,
}

export type IFormInputs = {
    question: string,
    chatMessageList: ChatData[],
    siteId: string,
}

export type PostParam = IFormInputs & {
    referrer: string,
}

export const Main2 = () => {

    const height = use100vh();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isChatLoading, setIsChatLoading] = useState<boolean>(false);
    const [isSnackOpen, setIsSnackOpen] = useState<boolean>(false);
    const [snackMessage, setSnackMessage] = useState<string>("");
    const [headerImage, setHeaderImage] = useState<Blob>(new Blob());
    const [headerText, setHeaderText] = useState<string>("");
    const [headerTextColor, setHeaderTextColor] = useState<string>("#000000");
    const [headercolor, setHaedercolor] = useState<string>("#FFFFFF");
    const [backgroundcolor, setBackgroundcolor] = useState<string>("#FFFFFF");
    const [guestbubblebackgroundcolor, setGuestbubblebackgroundcolor] = useState<string>("#0af531");
    const [guestbubbletextcolor, setGuestbubbletextcolor] = useState<string>("#000000");
    const [adminbubblebackgroundcolor, setAdminbubblebackgroundcolor] = useState<string>("#f70808");
    const [adminbubbletextcolor, setAdminbubbletextcolor] = useState<string>("#000000");
    const [footerbackgroundcolor, setFooterbackgroundcolor] = useState<string>("#F9FBFF");
    const [footerTextareaBackgroudColor, setFooterTextareaBackgroudColor] = useState<string>("#FFFFFF");
    const [footerTextareaTextColor, setFooterTextareaTextColor] = useState<string>("#000000");
    const [footerTextareaPlaceholderColor, setFooterTextareaPlaceholderColor] = useState<string>("#000000");
    const [footerText, setFooterText] = useState<string>("こちらに質問をどうぞ");
    const [adminIcon, setAdminIcon] = useState<Blob>(new Blob);
    const [guestIcon, setGusetIcon] = useState<Blob>(new Blob);
    const [footerButtonIcon, setFooterButtonIcon] = useState<Blob>(new Blob);
    const [cookies, setCookie, removeCookie] = useCookies(['csrftoken']);
    const [isEnableInit, setIsEnableInit] = useState<boolean>(false);
    const [iframeObject, setIframeObject] = useState(window != window.parent);

    const [csrfToken, setCsrfToken] = useState<string>("");

    const [initMessageList, setInitMessageList] = useState<ChatData[]>([]);
    const [count, setCount] = useState<number>(0);
    const [streamStr, setStreamStr] = useState<string>("");
    const [streamFlg, setStreamFlg] = useState<boolean>(false);

    const messagesEndRef = useRef<HTMLDivElement>(null);
    const scrollToLatest = useCallback(() => {
        messagesEndRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "end",
        })
    }, [messagesEndRef]);

    /* css */

    const cht_header_iconfile = css`
        background-image: url(${URL.createObjectURL(headerImage)});
    `

    const cht_agent_iconfile = css`
        background-image: url(${URL.createObjectURL(adminIcon)});
    `

    const cht_headber_color = css`
        background: ${headercolor};
        color: ${headerTextColor};
    `

    const cht_content_color = css`
        background-color: ${backgroundcolor};
    `

    const cht_agent_textcolor = css`
        color: ${adminbubbletextcolor};
    `

    const cht_agent_bubble_after = css`
        background: ${adminbubblebackgroundcolor};
        ::after {
            border-color: transparent ${adminbubblebackgroundcolor};
        }
    `

    const cht_customer_bubbleafter = css`
        background: ${guestbubblebackgroundcolor};
        ::after {
            border-color: transparent ${guestbubblebackgroundcolor};
        }
    `

    const cht_customer_textcolor = css`
        color: ${guestbubbletextcolor};
    `

    const cht_footer_background = css`
        background-color: ${footerbackgroundcolor};
    `

    const cht_footer_textarea = css`
        color: ${footerTextareaTextColor};
        background-color: ${footerTextareaBackgroudColor};
        ::placeholder {
            color: ${footerTextareaPlaceholderColor};
        }
    `

    /*const cht_footer_textarea = css`
        color: red;
        background-color: ${footerTextareaBackgroudColor};
    `*/

    const sendButtonImage = css`
        background-image: url(${URL.createObjectURL(footerButtonIcon)});
    `

    const eachAnimation = css`
        span{opacity: 0;}
        span{ animation:text_anime_on 1s ease-out forwards; }
        @keyframes text_anime_on {
            0% {opacity:0;}
            100% {opacity:1;}
        }
    `

    /* css */

    const location = useLocation();
    const pageParam = queryString.parse(location.search) as PageParam

    const [chatList, setChatList] = useState<ChatData[]>(
        []
    )

    const schema = Yup.object({
        question: Yup.string().required("必須項目です。"),
    }).required();

    const { register, handleSubmit, trigger, control, getValues, watch, formState: { errors, isValid }, setValue, reset } = useForm<IFormInputs>({
        defaultValues: {
            question: "",
            chatMessageList: [
                ...initMessageList,
            ],
            siteId: pageParam.siteid,
        },
        resolver: yupResolver(schema),
        mode: "onSubmit",
        reValidateMode: "onSubmit",        
    });

    const { fields, append, remove, insert, update } = useFieldArray({
        name: "chatMessageList",
        control: control
    });

    const onQuestionEnterKey = async (keyEvent: React.ReactEventHandler<HTMLTextAreaElement>) => {
        //if(keyEvent.)
    }

    const wait = async (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {

        const interval = setInterval(() => {
            setCount(c => { return c >= 3 ? 0 + 1 : c + 1 });
        }, 500);
        
        if (isLoading || streamFlg || isChatLoading) return;
        /*scrollToLatest();
        setIsChatLoading(true);
        await wait(10000);
        console.log(`before:${fields.length}`);
        append([
            { guestMessage: data.question, guestMessageTime: new Date(), adminMessage: "", adminMessageTime: new Date(), messageType: ChatMessageType.userdata },
        ]);
        console.log(`after:${fields.length}`);
        setValue("question", "");
        scrollToLatest();
        setIsChatLoading(false);
        
        const tt = data.question;
        let answerStr: string = "";
        for(let i = 0;i < tt.length; i++){
            console.log(fields.length);
            answerStr = answerStr.concat(tt.charAt(i));
            console.log(answerStr);
            fields[0].adminMessage = answerStr;
            update(fields.length -2,
                { guestMessage: data.question, guestMessageTime: new Date(), adminMessage: answerStr, adminMessageTime: new Date(), messageType: ChatMessageType.userdata }
            );
        }*/
        let answerStr: string = "";
        setIsChatLoading((value) => { return true });
        await UploadFile<ResponseParam>(ApiUrl.ChatRequest,
            {...data, referrer: document.referrer},
            null)
            .then(async response => {
                if (response.data.resultFlg) {
                    if((pageParam.isstream === undefined || pageParam.isstream === null) && pageParam.isstream != "0")
                    {
                        setStreamStr((value) => {return ""});
                        setStreamFlg((value) => { return true });
                        setIsChatLoading((value) => { return false });
                        for(let i = 0;i < response.data.answer.length; i++){
                            setStreamStr((value) => { return value.concat(response.data.answer.charAt(i)) });
                            await wait(25);
                        }
                        setStreamFlg((value) => { return false });
                    } else {                    
                        setStreamFlg((value) => { return false });
                        setIsChatLoading((value) => { return false });
                    }

                    append([
                        { guestMessage: response.data.question, guestMessageTime: new Date(), adminMessage: response.data.answer, adminMessageTime: new Date(), messageType: ChatMessageType.userdata },
                    ]);
                    setValue("question", "");
                    scrollToLatest();
                } else {
                    setStreamStr((value) => {return ""});
                    setStreamFlg((value) => { return false });
                    setIsChatLoading((value) => { return false });
                    setSnackMessage(response.data.message);
                    setIsSnackOpen(true);
                }
            })
            .catch((e) => {
                setStreamFlg((value) => { return false });
                setIsChatLoading((value) => { return false });
                UploadFile<ResponseParamBase>(
                    ApiUrl.ChatErrorMessage,
                    {
                        "question": data.question,
                    },
                    setIsLoading,
                ).then((errorResponse) => {
                    setSnackMessage(errorResponse.data.message);
                    setIsSnackOpen(true);
                })
                /*if (isAxiosError(e)) {
                    setSnackMessage("回答の取得に失敗しました。");
                    setIsSnackOpen(true);
                }*/
            })
            .finally(() => {
                clearInterval(interval);
            });
    }

    useEffect(() => {
        (async () => {
            try {
                //const token = await getCsrfToken();
                //setCsrfToken(token);
                setIsLoading((value) => { return true });
                Promise.all([
                    await UploadFile<InitResponseParam>(
                        ApiUrl.InitChat,
                        {
                            "siteId": getValues("siteId"),
                        },
                        null
                    ),
                    await UploadFile<Blob>(
                        ApiUrl.ChatHeaderImage,
                        {
                            "siteId": getValues("siteId"),
                            "imageType": UploadImageType.headerImage,
                        },
                        null,
                        "blob"
                    ),
                    await UploadFile<Blob>(
                        ApiUrl.ChatHeaderImage,
                        {
                            "siteId": getValues("siteId"),
                            "imageType": UploadImageType.chatAdminIcon,
                        },
                        null,
                        "blob"
                    ),
                    await UploadFile<Blob>(
                        ApiUrl.ChatHeaderImage,
                        {
                            "siteId": getValues("siteId"),
                            "imageType": UploadImageType.chatGuestIcon,
                        },
                        null,
                        "blob"
                    ),
                    await UploadFile<Blob>(
                        ApiUrl.ChatHeaderImage,
                        {
                            "siteId": getValues("siteId"),
                            "imageType": UploadImageType.sendButtonIcon,
                        },
                        null,
                        "blob"
                    ),
                ]).then(([Initparam, headerimage, adminIconResponse, guestIconResponse, footerBottonIconResponse]) => {
                    setBackgroundcolor((value) => { return Initparam.data.backgroundColor });
                    setHaedercolor((value) => { return Initparam.data.headerColor });
                    setHeaderTextColor((value) => { return Initparam.data.headerTextColor });

                    setGuestbubblebackgroundcolor((value) => { return Initparam.data.guestBubbleBackgroundColor });
                    setGuestbubbletextcolor((value) => { return Initparam.data.guestBubbleTextColor });

                    setAdminbubblebackgroundcolor((value) => { return Initparam.data.adminBubbleBackgroundColor });
                    setAdminbubbletextcolor((value) => { return Initparam.data.adminBubbleTextColor });

                    setFooterbackgroundcolor((value) => { return Initparam.data.footerBackgroundColor });
                    setFooterTextareaTextColor((value) => { return Initparam.data.footerTextColor });
                    setFooterTextareaPlaceholderColor((value) => { return Initparam.data.footerTextareaPlaceholderColor });
                    setFooterTextareaBackgroudColor((value) => { return Initparam.data.footerTextareaColor });
                    setHeaderImage((value) => { return headerimage.data });
                    setHeaderText((value) => { return Initparam.data.headerTitle });
                    setAdminIcon((value) => { return adminIconResponse.data });
                    setGusetIcon((value) => { return guestIconResponse.data });
                    setFooterButtonIcon((value) => { return footerBottonIconResponse.data });
                    setFooterText((value) => { return Initparam.data.footerText });
                    setInitMessageList((value) => {
                        setValue("chatMessageList", Initparam.data.initTextList);
                        return Initparam.data.initTextList;
                    });
                    setIsEnableInit((value) => { return Initparam.data.resultFlg })
                    if (!Initparam.data.resultFlg){
                        setSnackMessage((value) => { return Initparam.data.message });
                        setIsSnackOpen((value) => {return true});
                    }
                })
            } catch (error) {
                alert('表示に必要なデータが取得できませんでした。');
            } finally {
                setIsLoading((value) => { return false });
                scrollToLatest();
            }            

            /*await UploadFile<InitResponseParam>(
                ApiUrl.InitChat,
                {"siteId": getValues("siteId")},
                setIsLoading
            ).then((response) => {
                setBackgroundColor((value) => {return response.data.backgroundcolor});
                setBubblebackgroundcolor((value) => {return response.data.bubblebackgroundcolor});
                setFooterbackgroundcolor((value) => {return response.data.footerbackgroundcolor});
            }).catch((e) => {
                alert(e);
            })
            await UploadFile<Blob>(
                ApiUrl.ChatHeaderImage,
                {
                    "siteId": getValues("siteId"),

                },
                setIsLoading,
                "blob"
            ).then((response) => {
                setHeaderImage((value) => {return response.data})
            })*/
        })()
    }, [])

    useLayoutEffect(() => {
        scrollToLatest();
    })

    const textareaRef = useRef<HTMLTextAreaElement>(null);

    const resizeTextHeight = (textarea: RefObject<HTMLTextAreaElement>) => {
        if (textarea.current != null) {
            textarea.current.style.height = '40px';
            const scrollHeight = textarea.current.scrollHeight;
            textarea.current.style.height = `${scrollHeight}px`;
        }
    }

    const myStyle = {
        '& .MuiInputBase-input': {
            color: footerTextareaTextColor,
            backgroundcolor: footerTextareaBackgroudColor,
        },
        '& input::placeholder': {
            color: footerTextareaPlaceholderColor,
        },
        '& label': {
            color: '#AAAAAA', // 通常時のラベル色 
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: footerTextareaBackgroudColor, // 通常時のボーダー色
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottomColor: footerTextareaBackgroudColor,  // ホバー時のボーダー色
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: footerTextareaBackgroudColor,    // 通常時のボーダー色(アウトライン)
            },
            '&:hover fieldset': {
                borderColor: footerTextareaBackgroudColor,    // ホバー時のボーダー色(アウトライン)
            },
        },
    }

    const cht_body = css`
        background-color: ${backgroundcolor};
        padding: 20px;
        white-space: pre-wrap;
        overflow-x: hidden;
        overflow-y: scroll;
        flex-grow: 1;
    `
    const cht_flex_div = css`
        display: flex;
        margin: 0;
        flex-direction: column;
        height: ${height ? height : '100vh'};
    `
    const cht_header_container = css`
        display: flex;
        flex-direction: row;
        margin: 0;
    `

    return (
        <>
            <div style={{display: "flex", margin: 0, flexDirection: "column", height: height ? height : '100vh'}}>
                <div css={cht_header_container}>
                    <div key={1} css={[cht_headber, cht_headber_color]}>
                        <div css={[cht_agent_icon, cht_header_iconfile]}></div>
                        <div css={cht_headber_title}>{headerText}</div>
                    </div>
                </div>
                <div css={cht_body}>
                    {              
                        isLoading ?
                        <div className={basecss['circularprogress']}>
                            <CircularProgress></CircularProgress>
                        </div>
                        :
                        fields.map((field, index) => {
                            return (
                                <>
                                    {
                                        field.messageType === ChatMessageType.system ?
                                            <div key={field.id} css={cht_agent_container}>
                                                <div css={[cht_agent_icon, cht_agent_iconfile]}></div>
                                                <div css={[cht_agent_bubble_cont, bubble, cht_agent_bubble_after]}>
                                                    <div css={cht_agent_textcolor}>{field.adminMessage}</div>
                                                </div>
                                            </div>
                                            :
                                            <>
                                                <div key={field.id}>
                                                <div css={cht_customer_container}>
                                                    <div css={[cht_customer_bubble_cont, bubble, cht_customer_bubbleafter]}>
                                                        <div css={cht_customer_textcolor}>{field.guestMessage}</div>
                                                    </div>
                                                </div>
                                                <div css={cht_agent_container}>
                                                    <div css={[cht_agent_icon, cht_agent_iconfile]}></div>
                                                    <div css={[cht_agent_bubble_cont, bubble, cht_agent_bubble_after]}>
                                                        <div css={[cht_agent_textcolor]}>{field.adminMessage}</div>
                                                    </div>
                                                </div>
                                                </div>
                                            </>
                                        }
                                    </>
                                )
                            })
                    }                    
                    {
                        isChatLoading || streamFlg ?
                        <>
                            <div css={cht_customer_container}>
                                <div css={[cht_customer_bubble_cont, bubble, cht_customer_bubbleafter]}>
                                    <div css={cht_customer_textcolor}>{watch("question")}</div>
                                </div>
                            </div>
                            <div css={cht_agent_container}>
                                <div css={[cht_agent_icon, cht_agent_iconfile]}></div>
                                <div css={[cht_agent_bubble_cont, bubble, cht_agent_bubble_after]}>
                                    <div css={cht_agent_textcolor}>{
                                        isChatLoading ?
                                        count == 1 ?
                                            ".  "
                                            :
                                            count == 2 ?
                                            ".. "
                                            :
                                            "..."
                                        :
                                        streamStr
                                    }</div>
                                </div>
                            </div>
                        </>
                        :
                        null
                    }                    
                    <div ref={messagesEndRef}></div>
                </div>                                
                <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                    <div id="footer" css={[cht_footer, cht_footer_background]}>
                        <div style={{ width: "100%" }}>                            
                            <Controller
                                control={control}
                                name="question"
                                render={({ field }) => (
                                    <InputBase
                                        disabled={isChatLoading || streamFlg}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                if (!e.shiftKey && !e.altKey) {
                                                    //console.log('handleSubmit');
                                                    handleSubmit(onSubmit)(e);
                                                    e.cancelable = true;
                                                }
                                            }
                                        }}                                        
                                        inputProps={
                                            {
                                                style: {
                                                    color: footerTextareaTextColor,
                                                    backgroundColor: footerTextareaBackgroudColor,
                                                    borderRadius: "5px 5px 5px 5px",
                                                    paddingLeft: "5px",
                                                    paddingRight: "5px",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    marginRight: "10px",
                                                },
                                                sx: {
                                                    '::placeholder': { color: footerTextareaPlaceholderColor }
                                                }
                                            }
                                        } fullWidth multiline {...field} {...register('question')} placeholder={footerText} maxRows={10}></InputBase>
                                )}
                            />
                        </div>
                        <div>
                            <input type="submit" disabled={isChatLoading || streamFlg || !isEnableInit} value="" css={[sendButton, sendButtonImage]} />                            
                        </div>
                    </div>                   
                </form>
            </div>            
            <Snack message={snackMessage} open={isSnackOpen} setOpen={setIsSnackOpen} color="warning" anchor={{ horizontal: "center", vertical: "bottom" }}></Snack>
        </>
    )
}